import type { TweetResponseAuth } from './tweetResponseAuth';
import type { TweetResponseAuthor } from './tweetResponseAuthor';
import type { TweetResponseBasicInfo } from './tweetResponseBasicInfo';
import type { TweetResponseEngagement } from './tweetResponseEngagement';
import type { TweetResponseMedia } from './tweetResponseMedia';
import type { TweetResponsePoll } from './tweetResponsePoll';
import type { TweetResponseReferencedTweet } from './tweetResponseReferencedTweet';
import type { TweetResponseTags } from './tweetResponseTags';
import type { TweetResponseUserInteraction } from './tweetResponseUserInteraction';

export interface TweetResponse {
  /** 인증 컨텍스트 정보 */
  auth?: TweetResponseAuth;
  /** 트윗 작성자 정보 */
  author?: TweetResponseAuthor;
  basicInfo?: TweetResponseBasicInfo;
  engagement?: TweetResponseEngagement;
  /** 미디어 정보 */
  media?: TweetResponseMedia;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: TweetResponsePoll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: TweetResponseReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: TweetResponseTags;
  /** 사용자 상호작용 정보 */
  userInteraction?: TweetResponseUserInteraction;
}
